<div class="search">
  <mat-form-field>
    <input matInput placeholder="keyword" (input)="handleKeywordInput($event)" [value]="keyword" />
  </mat-form-field>
  <button
    mat-raised-button
    color="primary"
    (click)="handleSerchButtonClick()"
    [disabled]="isDisabled"
    class="button"
  >
    Search Tweet
  </button>
</div>
